const rankingItems = [
  { title: '千万粉丝美食博主后厨卫生翻车，前员工实名举报', heat: '9823万阅读' },
  { title: '带货一姐直播间「纯金」变铜合金，监管部门介入', heat: '8756万阅读' },
  { title: '某男团成员深夜密会素人，粉丝站集体关站', heat: '7642万阅读' },
  { title: '冠军战队内部录音曝光，疑似解散重组', heat: '6531万阅读' },
  { title: '情感博主「母单人设」崩塌，真实已婚有子', heat: '5421万阅读' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-20 md:py-28 bg-accent-500">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-background-950 mb-14">
          瓜榜：今日热度风云榜
        </h2>

        <div className="flex flex-col gap-4">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 md:gap-6 bg-background-950 rounded-full px-5 md:px-8 py-4 md:py-5 hover:bg-background-200 transition-colors duration-200 cursor-default group"
            >
              <span
                className={`text-2xl md:text-3xl font-black font-heading w-10 text-center ${
                  idx < 3 ? 'text-accent-500' : 'text-foreground-400'
                }`}
              >
                {idx + 1}
              </span>
              <h3 className="flex-1 text-sm md:text-base font-bold text-foreground-50 font-heading leading-snug line-clamp-1">
                {item.title}
              </h3>
              <span className="text-xs md:text-sm text-foreground-400 whitespace-nowrap font-medium">
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}